import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CustomDotCmsContentlet } from '../../../../models/contentlet/custom-dotcms-contentlet.model';
import { Observable } from 'rxjs';
import { DotCmsFacade } from '../../../../facades/dot-cms.facade';

@Component({
  selector: 'custom-dot-cms-blog-detail',
  templateUrl: './dot-cms-blog-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsBlogDetailComponent implements OnInit {
  previousUrl$: Observable<string>;
  @Input() contentlet: CustomDotCmsContentlet;
  @Input() identifier: string;
  constructor(private dotCmsFacade: DotCmsFacade) {}
  ngOnInit() {
    this.previousUrl$ = this.dotCmsFacade.getPreviousUrl();
  }
  buildImageSrc(imageKey: string) {
    return this.dotCmsFacade.generateImageURIFromImageKey(this.identifier, imageKey);
  }
  getTags(tagString: string): string[] {
    if (tagString) {
      return tagString.split(',');
    }
  }
}
